import ShopaholicCartAdd    from './shopaholic-cart/shopaholic-cart-add';
import ShopaholicCartRemove from './shopaholic-cart/shopaholic-cart-remove';
import ShopaholicCartClear from './shopaholic-cart/shopaholic-cart-clear';
import Notify               from 'simple-notify';

export default class CatalogItem {
	constructor({
		buttonAddClass = '_shopaholic-cart-add',
		miniCartWrapperClass = '.header__cart',
		cartPage = '.cart__wrapper',
		cartPositionList = '.cart-item'
	}) {
		this.buttonAddClass       = buttonAddClass;
		this.miniCartWrapperClass = miniCartWrapperClass;
		this.cartPage             = cartPage;
		this.cartPositionList     = cartPositionList;
		this.notifyConfig         = {
			status         :'success',
			effect         :'fade',
			speed          :300,
			showIcon       :true,
			showCloseButton:true,
			autoclose      :true,
			autotimeout    :3000,
			gap            :20,
			distance       :20,
			type           :1,
			position       :'right top'
		}
		this.obList               = null;
		
		this.init();
	}
	
	addListenerToAddCartButton() {
		const obShopaholicCartAdd = new ShopaholicCartAdd();
		obShopaholicCartAdd.setAjaxRequestCallback((obRequestData, obButton) => {
			obButton.classList.add('b-btn--loading');
			
			obRequestData.update   = {
				'shopaholic/widgets/minicart':this.miniCartWrapperClass
			};
			obRequestData.error    = (error) => {
				console.error(error);
			};
			obRequestData.complete = () => {
				this.updateAfterAddAjax(obButton);
			};
			return obRequestData;
		}).init();
	}
	
	addListenerToItemCartRemoveButton() {
		const obShopaholicCartRemove = new ShopaholicCartRemove();
		obShopaholicCartRemove.setAjaxRequestCallback((obRequestData, obButton) => {
			const itemList = document.querySelector('.cart-item').querySelectorAll('.item-cart').length;
			
			obButton.classList.add('item-cart__btn--loading');
			
			if (itemList > 1) {
				obRequestData.update = {
					'shopaholic/widgets/minicart':this.miniCartWrapperClass,
					'shopaholic/checkout/list'   :this.cartPositionList
				};
			} else {
				obRequestData.update = {
					'shopaholic/widgets/minicart':this.miniCartWrapperClass,
					'shopaholic/checkout/page'   :this.cartPage
				};
			}
			
			obRequestData.error    = (error) => {
				console.error(error);
			};
			obRequestData.complete = () => {
				this.updateAfterRemoveAjax(obButton);
			};
			return obRequestData;
		}).init();
	}
	
	addListenerToClearCartButton() {
		const obShopaholicCartClear = new ShopaholicCartClear();
		obShopaholicCartClear.setAjaxRequestCallback((obRequestData, obButton) => {
		
			obButton.classList.add('cart-detail__clean--loading');
			
			obRequestData.update = {
				'shopaholic/widgets/minicart':this.miniCartWrapperClass,
				'shopaholic/checkout/page'   :this.cartPage
			};
			
			obRequestData.error    = (error) => {
				console.error(error);
			};
			obRequestData.complete = () => {
				this.updateAfterClearAjax(obButton);
			};
			return obRequestData;
		}).init();
	}
	
	updateAfterAddAjax(obButton) {
		obButton.classList.remove('b-btn--loading');
		obButton.removeAttribute('disabled');
		const notifyConfig = this.notifyConfig;
		Object.assign(notifyConfig, {
			title:'Товар добавлен в корзину!'
		});
		new Notify(notifyConfig);
	}
	
	updateAfterRemoveAjax(obButton) {
		const notifyConfig = this.notifyConfig;
		Object.assign(notifyConfig, {
			title:'Товар удален из корзины!'
		});
		new Notify(notifyConfig);
	}
	
	updateAfterClearAjax(obButton) {
		const notifyConfig = this.notifyConfig;
		Object.assign(notifyConfig, {
			title:'Корзина очищена!'
		});
		new Notify(notifyConfig);
	}
	
	init() {
		this.addListenerToAddCartButton();
		this.addListenerToItemCartRemoveButton();
		this.addListenerToClearCartButton();
	}
}
